import script from "./MultipleOrders.vue?vue&type=script&setup=true&lang=ts"
export * from "./MultipleOrders.vue?vue&type=script&setup=true&lang=ts"

import "./MultipleOrders.vue?vue&type=style&index=0&id=74ec46c6&scoped=true&lang=scss"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74ec46c6"]])

export default __exports__